import { ContainerFluid, Flex } from "components/base/container";
import LayoutFooter from "./layout.footer";
import LayoutHeader from "./layout.header";

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <Flex width={"100%"} height={"100vh"} col>
      <LayoutHeader />
      <ContainerFluid overflow={"auto"}>
        {children}
        <LayoutFooter />
      </ContainerFluid>
    </Flex>
  );
};

export default Layout;
